import { Box, Button, ListItem, ListItemIcon, ListItemText, List } from '@mui/material'
import { CarePlanItem } from '../carePlanTypes'
import { FFModal } from '~/shared/ui'
import { useState } from 'react'
import CheckIcon from '@mui/icons-material/Check'
import { usePersonCaseCategoriesById } from '~/entities/case'
interface ICarePlanActionModalProps {
  carePlan: CarePlanItem
  action: string
  onCarePlanActionChange: (action: string) => void
  closeModal: () => void
}

const CarePlanActionModal = (props: ICarePlanActionModalProps) => {
  const { carePlan, onCarePlanActionChange, action, closeModal } = props
  const [loading, setLoading] = useState<boolean>(false)
  const allTasks = carePlan.tasks ?? []
  const activeTasks = allTasks.filter(task => !task.is_complete)
  // Use full catalog for case titles in the modal
  const { result: caseCategoriesById } = usePersonCaseCategoriesById(null)
  const openCases = carePlan.cases ?? []
  const acknowledged = () => {
    setLoading(true)
    try {
      onCarePlanActionChange(action)
      setLoading(false)
      closeModal()
    } catch (error) {
      setLoading(false)
    }
  }
  return (
    <FFModal open={true}>
      <>
        <Box sx={{ m: 2 }}>
          <h1>
            <b>Are you sure you want to deactivate this care plan?</b>
          </h1>
          {activeTasks.length > 0 && (
            <div>
              <h3>
                <b>{activeTasks.length} task(s) will be deleted:</b>
              </h3>
              <List>
                {activeTasks.map(task => {
                  return (
                    <ListItem key={task.id}>
                      <ListItemIcon>
                        <CheckIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <b>{task.title}</b>
                      </ListItemText>
                    </ListItem>
                  )
                })}
              </List>
            </div>
          )}
          {openCases.length > 0 && (
            <div>
              <h3>
                <b>{openCases.length} case(s) will be unlinked:</b>
              </h3>
              <List>
                {openCases.map(openCase => {
                  return (
                    <ListItem key={openCase.id}>
                      <ListItemIcon>
                        <CheckIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <b>{caseCategoriesById[openCase.category]?.title ?? ''}</b>
                      </ListItemText>
                    </ListItem>
                  )
                })}
              </List>
            </div>
          )}

          <Box sx={{ m: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={() => closeModal()} disabled={loading}>
              Cancel
            </Button>
            <Button
              onClick={() => acknowledged()}
              disabled={loading}
              color="primary"
              variant="contained"
            >
              OK
            </Button>
          </Box>
        </Box>
      </>
    </FFModal>
  )
}

export default CarePlanActionModal
